import React from "react";

function Footer() {
  return (
    <div className="footer">
      <footer class="footer py-5">
        <div class="container">
          <p class="m-0 text-center text-white">
            Copyright &copy; Helping Hand 2020
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
